function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M18.44 8.33v8.63c0 .77-.63 1.4-1.4 1.4H2.97c-.77 0-1.4-.63-1.4-1.4V8.33c0-.33-.27-.6-.6-.6-.33 0-.6.27-.6.6v8.63c0 1.44 1.17 2.6 2.6 2.6h14.07c1.43 0 2.6-1.17 2.6-2.6V8.33c0-.33-.27-.6-.6-.6-.33 0-.6.27-.6.6z",
  fill: "#7F63FF"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.58.91l-4 4a.61.61 0 000 .85c.23.23.61.23.85 0L9.4 2.79v11.19c0 .33.27.6.6.6.33 0 .6-.27.6-.6V2.78l2.97 2.97c.23.23.61.23.85 0 .12-.12.18-.27.18-.42 0-.15-.06-.31-.18-.42l-4-4A.56.56 0 0010 .73a.56.56 0 00-.42.18z",
  fill: "#7F63FF"
});

function SvgUpload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "34aad251c719c42b5e07383bb04f72d4.svg";
export { SvgUpload as ReactComponent };